import { createContext, useCallback, useContext, useEffect, useRef, useState } from "react";
import { getApi, putApi } from "../../services/api/globalApi";
import { DEFAULT_SIDEBAR_ORDER, normalizeSidebarOrder } from "./sidebarItems";

const SidebarSettingsContext = createContext(null);
const path = "admin/settings/sidebar";

function readOrder(response) {
  const order = response?.data?.result?.order;
  if (!Array.isArray(order)) throw new Error("پاسخ تنظیمات سایدبار معتبر نیست.");
  return normalizeSidebarOrder(order);
}

export function SidebarSettingsProvider({ children }) {
  const [order, setOrder] = useState(DEFAULT_SIDEBAR_ORDER);
  const [isLoading, setIsLoading] = useState(true);
  const [isSaving, setIsSaving] = useState(false);
  const [loadError, setLoadError] = useState("");
  const requestId = useRef(0);

  const reload = useCallback(async () => {
    const id = ++requestId.current;
    setIsLoading(true);
    setLoadError("");
    try {
      const response = await getApi({ path });
      if (id === requestId.current) setOrder(readOrder(response));
    } catch (_) {
      if (id === requestId.current) {
        setLoadError("دریافت ترتیب ذخیره‌شده انجام نشد. لطفاً دوباره تلاش کنید.");
      }
    } finally {
      if (id === requestId.current) setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    reload();
    return () => { requestId.current += 1; };
  }, [reload]);

  const saveOrder = async (nextOrder) => {
    setIsSaving(true);
    try {
      const response = await putApi({ path, body: { order: nextOrder } });
      const savedOrder = readOrder(response);
      // Publishing happens only after the server confirms persistence.
      setOrder(savedOrder);
      return savedOrder;
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <SidebarSettingsContext.Provider value={{ order, isLoading, isSaving, loadError, reload, saveOrder }}>
      {children}
    </SidebarSettingsContext.Provider>
  );
}

export function useSidebarSettings() {
  return useContext(SidebarSettingsContext);
}
